<template>
  <div class="plan-model" v-if="visible">
    <div class="title">
      <p></p>
      <h3>{{ title }}</h3>
    </div>
    <div class="content">
      <!--  label-suffix="：" -->
      <el-scrollbar style="height: 100%">
        <el-form :model="form" :rules="rules" ref="ruleForm" label-width="122px" size="small" class="demo-ruleForm">
          <el-form-item label="随访计划名称" prop='itemName'>
            <el-input maxlength="20" type="text" placeholder="请输入随访计划名称" v-model.trim="form.itemName" clearable></el-input>
          </el-form-item>
          <el-form-item label="随访方式" prop='method'>
            <el-select v-model="form.method" placeholder="请选择随访方式" clearable>
              <el-option label="病人自主" :value="4"></el-option>
              <el-option label="个案评估" :value="5"></el-option>
              <el-option label="医生评估" :value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="随访类型" prop='executeType'>
            <el-select v-model="form.executeType" placeholder="请选择随访类型" clearable>
              <el-option label="线上" :value="1"></el-option>
              <el-option label="线下" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="随访频率" prop='cycle'>
            <div class="cycle-count-style">
              <el-input maxlength="20" type="text" :disabled="form.cycleType == '时'" placeholder="请输入时长" v-model.trim="form.cycle" clearable style="width:90px;flex:unset"></el-input>
              <el-select v-model="form.cycleType" :disabled="form.cycleType == '时'" placeholder="请选择" clearable style="width:70px;margin:0 10px">
                  <el-option label="日" value="日"></el-option>
                  <el-option label="周" value="周"></el-option>
                  <el-option label="月" value="月"></el-option>
              </el-select>
              <el-input maxlength="20" type="text" :disabled="form.cycleType == '时'" placeholder="请输入" v-model.trim="form.cycleCount">
                <template slot="append">次</template>
              </el-input>
            </div>
            <!-- <el-select v-model="form.cycle" placeholder="请选择随访频率" clearable>
              <el-option label="每周一次" value="week_1"></el-option>
              <el-option label="每半个月一次" value="month_1_2"></el-option>
              <el-option label="每月一次" value="month_1"></el-option>
              <el-option label="每两个月一次" value="month_2"></el-option>
              <el-option label="每三个月一次" value="month_3"></el-option>
              <el-option label="每四个月一次" value="month_4"></el-option>
              <el-option label="每五个月一次" value="month_5"></el-option>
              <el-option label="每半年一次" value="month_6"></el-option>
              <el-option label="每年一次" value="year_1"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="提醒时间：">
              <!-- <div style="display:flex;align-items: center;" v-if="edit"> -->
              <div style="display:flex;align-items: center;">
                <span style="display: block;width: 40px;">提前</span>
                <el-input placeholder="请输入内容" v-model="form.itemTime" maxlength="2" @input="itemTimeChange">
                  <template slot="append">天</template>
                </el-input>
              </div>
              <!-- <span v-else>{{ form.itemTime }}</span> -->
            </el-form-item>
          <el-form-item label="随访属性" prop='attrs'>
            <el-radio-group v-model="form.attrs">
              <el-radio :label="1">长期</el-radio>
              <el-radio :label="2">短期</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="随访宣教属性" v-if="form.attrs == 2" prop='shortDays'>
            <el-input placeholder="请输入时间 " v-model.trim="form.shortDays" :maxlength="6" class="input-with-select">
              <el-select v-model="form.shortDaysType" slot="append" placeholder="" style="width:70px">
                <el-option label="天" value="天"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item label="随访内容备注" prop='description'>
            <el-input maxlength="200" type="textarea" :autosize="{ minRows: 2, maxRows: 6}" placeholder="请输入随访内容备注" v-model.trim="form.description"></el-input>
          </el-form-item>
          <el-form-item label="开始时间类型" prop='startTimeType'>
            <el-select v-model="form.startTimeType" placeholder="请选择方案开始时间">
               <el-option v-for="item in startTimeTypeList" :key="item.id" :label="item.name"
                :value="item.startTimeType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="与开始时间间隔" prop='startIntervalTime'>
            <el-input placeholder="请输入开始时间间隔" v-model.trim="form.startIntervalTime" :maxlength="6" class="input-with-select">
              <el-select v-model="form.startIntervalType" slot="append" placeholder="" style="width:70px">
                <el-option label="天" value="天"></el-option>
                <el-option label="周" value="周"></el-option>
                <el-option label="月" value="月"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="form={attrs:2,moduleCode:'JRTX',isTop:2,shortDaysType:'天',startIntervalType:'天',itemType: 3,itemTime:'',remindDate:''}">重置</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import local from '@/utils/local.js'

export default {
  name: "FollowPlan",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "随访计划方案"
    },
    formData: {
      type: Object,
      default: () => {}
    },
    startTimeTypeList:{
       type: Array,
       default: () => []
    }
  },
  data() {
    let checkCycle = (rule, value, callback) => {
      if (!value || !this.form.cycleType || !this.form.cycleCount) {
        return callback(new Error('请填写频率'));
      } else {
        // oninput="value=value.replace(/[^\d.]/g,'')"
        let valiReg = /^\+?[1-9]\d*$/
        if (!valiReg.test(value) || !valiReg.test(this.form.cycleCount)) {
          return callback(new Error('请输入正整数'));
        }
        if (Number(this.form.cycleCount) > 99) {
          return callback(new Error('次数限制1-99次'));
        }

        if (this.form.cycleType == '日') {
          if (Number(value) > 31) {
            return callback(new Error('输入时长限制为1-31'));
          }
        } else if (this.form.cycleType == '周') {
          if (Number(value) > 52) {
            return callback(new Error('输入时长限制为1-52'));
          }
        } else if (this.form.cycleType == '月') {
          if (Number(value) > 12) {
            return callback(new Error('输入时长限制为1-12'));
          }
        } callback()
      }
    };
    return {
      form: {
        attrs: 2,
        moduleCode: "JRTX",
        isTop: 2,
        shortDaysType: "天",
        startIntervalType: "天"
      },
      rules: {
        itemName: [
          { required: true, message: "请输入随访计划名称", trigger: "blur" }
        ],
        method: [
          { required: true, message: "请选择随访方式", trigger: "blur" }
        ],
        executeType: [
          { required: true, message: "请选择随访类型", trigger: "blur" }
        ],
        cycle: [{ required: true, validator: checkCycle, trigger: 'blur' }],
        attrs: [{ required: true, message: "请选择", trigger: "blur" }],
        shortDays: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value != "") {
                if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
                  callback(new Error("请填写大于等于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写随访宣教属性"));
              }
            },
            trigger: "blur"
          }
        ],
        shortDaysType: [{ required: true, message: "请选择", trigger: "blur" }],
        startTimeType: [
          { required: true, message: "请选择方案开始时间", trigger: "blur" }
        ],
        startIntervalTime: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value != "" || value === 0) {
                if (!/^([1-9]\d*|[0]{1,1})$/.test(value)) {
                  callback(new Error("请填写大于等于0的数字"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写开始时间间隔"));
              }
            },
            trigger: "blur"
          }
        ],
        startIntervalType: [
          { required: true, message: "请选择", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    formData(val) {
      this.form = val;
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (this.form.itemTime != '' && (this.form.itemTime < 1 || this.form.itemTime > 10)) {
          this.$message.error("提醒时间不能大于10并且不能小于1");
          return false;
        } else {
          this.form.remindDate = this.$dayTimeFun(this.form.itemTime);
        }
        if (valid) {
          this.form.schemeType = local.get("ADDRESS");
          if (this.form.attrs == 1) {
            this.form.shortDays = "";
          }
          this.$emit("updateTemplate", this.form);
        } else {
          return false;
        }
      });
    },
    itemTimeChange(e) {
      //提醒时间
      this.form.itemTime = e.replace(/[^\d]/g, "");
      // if (e === "0" || e > 10) {
      //   this.$message.error("提醒时间不能大于10并且不能小于1");
      // }
    }
  }
};
</script>

<style lang="less">
.plan-model {
  .el-scrollbar {
    .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }
}
</style>

<style lang="less" scoped>
@import "./index.less";
</style>